import { render } from "./BaseIcon.vue?vue&type=template&id=6cd85b15&ts=true"
import script from "./BaseIcon.vue?vue&type=script&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__